import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { noop } from 'lodash';
import moment from 'moment';
// this is not used directly, but has to be included
// noinspection ES6UnusedImports
import momentDurationFormatSetup from 'moment-duration-format'; // eslint-disable-line no-unused-vars
import { bindActionCreators } from 'redux';

import beCreateAppointment from 'actions/appointment/beCreateAppointment.action';
import { beFindReaderV1 } from 'actions/pos/beFindReader.action';
import { feSidebarAppointmentClear } from 'actions/ui.actions';
import closeIco from 'assets/images/close-btn-violet.svg';
import addserviceIco from 'assets/images/xAddserviceicon.svg';
import repeatBookingIco from 'assets/images/xRepeaticon.svg';
import depositIco from 'assets/images/xTakedepositicon.svg';
import { addSearchedService } from 'bl/services/addSearchedService.bl';
import { fromServicesToFlattened } from 'bl/services/calculateServicesPriceAndTimeRanges.bl';
import ToggleFeature from 'components/core/ToggleFeature.component';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import DatePickerInput from 'components/form/DatePickerInput.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import withSalonCurrency from 'components/hoc/withSalonCurrency.hoc';
import S from 'constants/string.const';
import {
  selectCurrentSalonId,
  selectCurrentSalonServices,
  selectCurrentSalonStylists,
} from 'selectors/currentSalon.selectors';
import { selectBookingClientTags } from 'selectors/simple';
import alen from 'utils/arrays/alen.util';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { fromPropsToIsWeek, fromPropsToPathSegments } from 'utils/converters/props/path.util';
import { formatDayToYearOrdinal } from 'utils/date/format.util';
import { nowAsMoment } from 'utils/date/now.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import currencySign from 'utils/intl/currencySign.util';
import navFor from 'utils/links/navFor.util';
import logger from 'utils/logger.util';

import {
  addService,
  appointmentAndDepositThunk,
  appointmentAndRepeatThunk,
  changeClient,
  cleanBookingData,
  createAppointmentWithProcedures,
  getClient,
  getFrequentlyBookedList,
  getPreferenceList,
  hasHighNoShowRate,
  pickCategory,
  removeService,
  updateAppointmentAndDepositThunk,
  updateAppointmentAndRepeatThunk,
  updateAppointmentWithProcedures,
} from 'booking/actions';
import BookingSummary from 'booking/components/BookingSummary';
import BackButton from 'booking/components/common/bw-header/BackButton';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import CategoryItem from 'booking/components/common/CategoryItem';
import BookingNotes from 'booking/components/common/client/BookingNotes';
import BWClientHeader from 'booking/components/common/client/BWClientHeader';
import DropdownService from 'booking/components/common/DropdownService';
import FrequentlyBtnComponent from 'booking/components/common/FrequentlyBtnComponent';
import FrequentlyButtonButton from 'booking/components/common/FrequentlyButton';
import SearchSelectBar from 'booking/components/common/SearchSelectBar';
import TextField from 'booking/components/common/TextField';
import ConfirmationModalComponent from 'common/PopupModal';
import { setCurrentDay } from 'scheduler/actions';
import { trackEvent } from 'tracking/actions';

import ServiceItem from './common/ServiceItem';

import CN from './ServiceSelection.module.scss';

const CTAG = 'ServiceSelection';
const L = logger(CTAG);

const RELOAD_MESSAGE = [
  'Your computer or device has just experienced a quick internet disconnect,',
  'therefore some of the data you selected has been lost.',
  'Please start the booking again from scratch.',
].join(S.space);

class WalkIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  toggleMenu = () => void this.setState({ isOpen: !this.state.isOpen });

  render() {
    return (
      <div className="dropdown">
        <div className="dropdown-button m-t-40">
          <span className="name label-name">Walk In</span>

          {!this.state.isOpen && (
            <div className="dots" role="button" onClick={this.toggleMenu} tabIndex={0}>
              <span />
              <span />
              <span />
            </div>
          )}
          {this.state.isOpen && (
            <div className="dots" style={{ opacity: 0.8 }} onClick={this.toggleMenu} tabIndex={0} role="button">
              <span />
              <span />
              <span />
            </div>
          )}
        </div>
        {this.state.isOpen && (
          <div className="simple-dropdown-results">
            <button
              className="btn btn-violet text-upper"
              onClick={() => {
                const createNew = this.props.pathArray.filter((o) => o !== 'services' && o !== 'summary').join('/');
                this.props.history.push(`${createNew}/client`);
              }}
            >
              Create Client
            </button>
          </div>
        )}
      </div>
    );
  }
}

class ServiceSelection extends React.Component {
  static defaultProps = { editClient: null };

  constructor(props) {
    super(props);
    const { startTime } = this.props;

    this.state = {
      category: false,
      changedPref: [],
      datePickerOpen: false,
      isSearching: false,
      modalClose: false,
      removedService: false,
      selectedDate: startTime || nowAsMoment(),
      serviceId: 0,
      showAddserviceBtn: false,
      showModal: false,
      showReloadPopup: false,
      showRepeatBtn: false,
      showTakeDepositBtn: false,
      hoverPastDay: false,
    };

    this.bookingSummaryRef = React.createRef();
  }

  componentDidMount() {
    const {
      changeClient,
      client,
      clientId,
      frequentServices,
      getClient,
      getPreferenceList,
      getFrequentlyBookedList,
      hasHighNoShowRate,
      salonId,
    } = this.props;

    if (clientId && salonId) {
      hasHighNoShowRate(clientId, salonId);

      if (frequentServices.length === 0) {
        getFrequentlyBookedList(clientId, salonId);
      }

      getClient(salonId, clientId);

      getPreferenceList(salonId, clientId);
    }

    changeClient(client);

    setTimeout(() => {
      const div = document.querySelector('.bw-content-wrapper.space');
      if (div) {
        div.scrollIntoView();
      }
    }, 100);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { client: ogClient, addedServices: ogAddedServices, location, preferenceList } = this.props;
    const { client: ngClient, addedServices: ngAddedServices, currentDay: ngCurrentDay } = nextProps;

    const ngFrequentServicesLength = alen(nextProps.frequentServices);

    if (!ngClient) {
      L.warn('UNSAFE_componentWillReceiveProps()', 'Invalid ngClient:', ngClient, { nextProps, props: this.props });

      // this is the result of an unintended reload
      this.setState({ showReloadPopup: true });

      const el = document.querySelector('.confirmation-modal.animated.zoomIn');
      if (el) el.style.zIndex = '5000';
    }

    if (ngFrequentServicesLength === 0 || ogClient === 'walkIn') {
      if (ngAddedServices.filter((s) => s.deleted !== true).length > 0) {
        this.setState({ showAddserviceBtn: true, showTakeDepositBtn: true, showRepeatBtn: true });
      }
    } else if (ngFrequentServicesLength > 0 || ogClient === 'walkIn') {
      if (ngAddedServices.filter((s) => s.deleted !== true).length > 0) {
        L.unignore('componentWillReceiveProps()', 'resolveAfterFound:', this.resolveAfterFound());
      }
    }

    if (
      ngAddedServices.length > 0 &&
      ngAddedServices.filter((s) => s.deleted !== true).length <
        ogAddedServices.filter((s) => s.deleted !== true).length
    ) {
      this.setState({ removedService: true });
    }

    if (preferenceList.length > 0) {
      const countAdded = ngAddedServices.length;
      if (countAdded > 0) {
        const newlyAddedService = ngAddedServices.filter((d) => d.deleted !== true)[countAdded - 1];
        if (newlyAddedService) {
          const prefExists = preferenceList.filter((c) => c.service === newlyAddedService.service_id);
          if (prefExists.length > 0) {
            if (newlyAddedService.stylist_id && newlyAddedService.stylist_id !== prefExists[0].stylist) {
              const { changedPref } = this.state;
              const newChangedPref = [prefExists[0].stylist, newlyAddedService.stylist_id];
              if (
                changedPref.length === 0 ||
                (changedPref.findIndex((p) => p.toString() === newChangedPref.toString()) < 0 &&
                  newChangedPref.indexOf(prefExists[0].stylist) < 0 &&
                  newChangedPref[1] !== null &&
                  newChangedPref[1] !== 0) // is null when not set
              ) {
                changedPref.push(newChangedPref);
                this.setState({ showModal: true, serviceId: newlyAddedService.local_id, changedPref });
              }
            }
          }
        }
      }
    }

    if (
      ogAddedServices.length > 0 &&
      moment(ngCurrentDay).get('date') !== moment(ogAddedServices[0].start_time).get('date') &&
      location.pathname.indexOf('/appointment/new/services') < 0
    ) {
      this.setBookingDate(ngCurrentDay);
    }
  }

  componentWillUnmount() {
    this.setState({ isUnmounted: true });
  }

  setSearching = (isSearching) => void this.setState({ isSearching });

  setBookingDate = (date) => {
    const { addedServices, setCurrentDay, trackEvent } = this.props;
    setCurrentDay(date.startOf('day'));
    this.setState({ selectedDate: date });
    trackEvent('ResheduleInBookingWindow');
    if (addedServices && addedServices.length > 0) {
      const newAddedServices = addedServices.slice();
      for (let i = 0; i < addedServices.length; i += 1) {
        const newStartTime = moment(newAddedServices[i].start_time);
        newStartTime.set({
          year: moment(date).get('year'),
          month: moment(date).get('month'),
          date: moment(date).get('date'),
          hour: newStartTime.get('hour'),
          minute: newStartTime.get('minute'),
          second: newStartTime.get('second'),
          millisecond: 0,
        });
        newAddedServices[i].start_time = newStartTime;
      }
    }
  };

  closeReloadPopup = () => {
    this.setState({ showReloadPopup: false });
    const newUrl = this.props.location.pathname.split('/appointment/new/services')[0];
    navFor(CTAG, 'closeReloadPopup()', this.props).push({ pathname: newUrl });
  };

  resolveAfterFound = () =>
    new Promise((resolve) => {
      // FIXME: do not use setInterval/clearInterval
      const interval = setInterval(() => {
        const { addedServices, client, clientId, frequentServices } = this.props;
        const isUnmounted = this.state.isUnmounted;

        // wait for when it's ok to show frequently booked bt
        const showButton =
          client &&
          clientId &&
          asArray(frequentServices).length > 0 &&
          asArray(addedServices).filter((s) => !s.deleted).length !== 0;

        if (!showButton) return;

        L.debug('resolveAfterFound()', 'Clearing interval:', interval, '...');
        clearInterval(interval); // FIXME: do not use setInterval/clearInterval

        const state = { showAddserviceBtn: true, showTakeDepositBtn: true, showRepeatBtn: true };

        if (isUnmounted) {
          L.warn('resolveAfterFound()', 'Not setting state:', state, 'due to isUnmounted:', isUnmounted);
        } else {
          L.debug('resolveAfterFound()', 'Setting state:', state, '...');
          this.setState(state);
        }

        resolve();
      }, 500);
    });

  goToFrequentlyList = () => {
    navFor(CTAG, 'goToFrequentlyList()', this.props).push({
      pathname: `${fromPropsToPathSegments(this.props)
        .filter((str) => str !== 'services')
        .join('/')}/frequently-booked`,
    });
  };

  goToClientProfile = () => {
    const { clientId, location } = this.props;
    if (clientId) {
      if (location.pathname.indexOf('services')) {
        navFor(CTAG, 'goToClientProfile()', this.props).push({
          pathname: `${fromPropsToPathSegments(this.props)
            .slice(0, -1) // remove services
            .join('/')}/client/${clientId}`,
        });
      }
    }
  };

  goBackToServiceList = () => {
    this.setState({ category: undefined });
  };

  pickCategory = (category) => {
    const { pickCategory } = this.props;
    pickCategory(category);
    navFor(CTAG, 'pickCategory()', this.props).push(`services/${encodeURI(category.name)}`);
  };

  showNoShowData = (hasHighNoShowRate) => {
    const { client } = this.props;
    if (hasHighNoShowRate.isFetching) {
      return <span>loading client no show data...</span>;
    } else if (!hasHighNoShowRate.isFetching && !hasHighNoShowRate.errorMessage) {
      if (hasHighNoShowRate.no_shows && hasHighNoShowRate.no_shows > 2) {
        return (
          <div
            className="text-center no-show-deposit-prompt"
            style={{
              color: 'rgb(211, 47, 47)',
              fontSize: '12px',
              display: 'block',
              fontWeight: '600',
            }}
          >
            <span className="deposit-promt-line-1">
              {client.user_name} has high no-show rate over the past 12 months. <br />
            </span>
            <span className="deposit-promt-line-2">
              There has been {hasHighNoShowRate.no_shows} no shows out of total of <br />
            </span>
            <span className="deposit-promt-line-3">
              {hasHighNoShowRate.appointments} appointments <br />
            </span>
            <span className="deposit-promt-line-4">
              It may be advisable to take a deposit. <br />
            </span>
            <br />
            <br />
          </div>
        );
      }
    }
    return <span className="no-show-deposit-prompt" />;
  };

  addNewService = (data) => {
    const { addService, preferenceList } = this.props;

    const prefs = asArray(preferenceList).filter((c) => c.service === data.service_id);
    if (prefs.length > 0 && data.stylist_id && data.stylist_id !== prefs[0].stylist) this.setState({ showModal: true });

    addService(data);

    this.setState({ showAddserviceBtn: true, showTakeDepositBtn: true, showRepeatBtn: true });
  };

  back = () => {
    const { clientId, salonId } = this.props;
    const pathArray = fromPropsToPathSegments(this.props);
    const isWeekView = fromPropsToIsWeek(this.prosp);
    if (pathArray[6] === 'new' || pathArray[7] === 'new') {
      navFor(CTAG, 'back()', 'new', this.props).back();
    } else if (clientId) {
      let path = `/salon/${salonId}/day/${pathArray[4]}/appointment/edit/${pathArray[7]}/select`;

      if (isWeekView) {
        path = `/salon/${salonId}/week/${pathArray[4]}/${pathArray[5]}/appointment/edit/${pathArray[8]}/select`;
      }

      navFor(CTAG, 'back()', 'clientId', this.props).push({ pathname: path });
    } else {
      let nPath = `/salon/${salonId}/day/${pathArray[4]}/appointment/edit/${pathArray[7]}`;

      if (isWeekView) {
        nPath = `/salon/${salonId}/week/${pathArray[4]}/${pathArray[5]}/appointment/edit/${pathArray[8]}`;
      }

      navFor(CTAG, 'back()', this.props).push({ pathname: nPath });
    }
  };

  repeatBooking = () => {
    const { isRepeatBooking } = this.props;
    if (isRepeatBooking) {
      return;
    }

    this.setState({ showRepeatBtn: false });
    navFor(CTAG, 'repeatBooking()', this.props).push({
      pathname: `${fromPropsToPathSegments(this.props)
        .filter((str) => str !== 'summary')
        .filter((str) => str !== 'services')
        .join('/')}/repeatbooking`,
    });
  };

  goToAddService = () => {
    navFor(CTAG, 'goToAddService()', this.props).push({
      pathname: `${fromPropsToPathSegments(this.props)
        .filter((str) => str !== 'summary')
        .filter((str) => str !== 'services')
        .join('/')}/addanotherservice`,
    });
  };

  goToEditClientProfile = () => {
    const { clientId, trackEvent, location } = this.props;
    if (clientId) {
      trackEvent('edit_view_profile');

      if (location.pathname.indexOf('/summary')) {
        navFor(CTAG, 'goToEditClientProfile()', '/summary', this.props).push({
          pathname: `${fromPropsToPathSegments(this.props)
            .slice(0, -1) // remove last elm from array 'summary'
            .join('/')}/client/edit/${clientId}`,
        });
      } else if (this.props.location.pathname.indexOf('/appointment/new/services')) {
        navFor(CTAG, 'goToEditClientProfile()', '/appointment/new/services', this.props).push({
          pathname: `${fromPropsToPathSegments(this.props)
            .slice(0, -2) // remove last elm from array 'appointment/new/services'
            .join('/')}/client/edit/${clientId}`,
        });
      }
    }
  };

  goToPatchView = () => {
    const { clientId, location, trackEvent } = this.props;

    if (location.pathname.indexOf('/summary')) {
      if (clientId) {
        trackEvent('goto_patch_view');

        navFor(CTAG, 'goToPatchView()', '/summary', this.props).push({
          pathname: `${fromPropsToPathSegments(this.props)
            .slice(0, -1) // remove last elm from array 'summary'
            .join('/')}/client/${clientId}`,
          state: { fromNoPatch: true },
        });
      }
    } else if (location.pathname.indexOf('/appointment/new/services')) {
      if (clientId) {
        trackEvent('goto_patch_view');

        navFor(CTAG, 'goToPatchView()', '/appointment/new/services', this.props).push({
          pathname: `${fromPropsToPathSegments(this.props)
            .slice(0, -3) // remove last elm from array 'appointment/new/services'
            .join('/')}/client/${clientId}`,
          state: { fromNoPatch: true },
        });
      }
    }
  };

  openDatePicker = () => {
    this.props.trackEvent('create_datebar');
    this.setState({ datePickerOpen: !this.state.datePickerOpen });
  };

  saveBooking = () => {
    const bookingSummary = this.bookingSummaryRef && this.bookingSummaryRef.current;
    const saveBooking = typeof bookingSummary.saveBooking === 'function' ? bookingSummary.saveBooking : noop;

    if (bookingSummary) {
      saveBooking();
    }
  };

  takeDeposit = () => {
    const { deposit } = this.props;

    if (deposit) {
      return;
    }

    this.setState({ showTakeDepositBtn: false });

    const pathname = `${fromPropsToPathSegments(this.props)
      .filter((s) => s !== 'summary')
      .filter((s) => s !== 'services')
      .join('/')}/deposit`;

    navFor(CTAG, 'takeDeposit()', this.props).push({ pathname });
  };
  // GS-4701 hover on past day and display tooltip
  handleMouseOver = (ev) => {
    if (ev.target.closest('.react-datepicker__day.is-past-day')) {
      this.setState({ hoverPastDay: true });
    }
  };

  handleMouseOut = (ev) => {
    if (ev.target.closest('.react-datepicker__day.is-past-day')) {
      this.setState({ hoverPastDay: false });
    }
  };

  handleSelectedSearchedItem = (service) => {
    const { client, addedServices, addService, location, history } = this.props;
    addSearchedService({ service, client, addedServices, addService, location, history });
  };

  render() {
    const {
      addedServices,
      appointmentAndDepositThunk,
      appointmentAndRepeatThunk,
      beFindReader,
      beCreateAppointment,
      bookingNotes,
      changeRepeatUntil,
      cleanBookingData,
      client,
      clientNoShowData,
      clientId,
      clientTags,
      createAppointmentWithProcedures,
      currentDay,
      deposit,
      depositTaken,
      editClient,
      frequency,
      frequencyType,
      frequentServices,
      history,
      isFetching,
      isFetchingService,
      isRepeatBooking,
      location,
      match,
      removeService,
      salonId,
      services,
      startTime,
      stylistList,
      until,
      updateAppointmentAndDepositThunk,
      updateAppointmentAndRepeatThunk,
      updateAppointmentWithProcedures,
      currentSalonAbbr,
      currentSalonSign,
    } = this.props;

    const {
      category,
      datePickerOpen: isDatePickerOpen,
      isSearching,
      modalClose,
      removedService,
      selectedDate,
      serviceId,
      showAddserviceBtn: isAddButtonShown,
      showModal,
      showReloadPopup,
      showRepeatBtn: isRepeatButtonShown,
      showTakeDepositBtn: isTakeButtonShown,
      hoverPastDay,
    } = this.state;

    const pathSegments = fromPropsToPathSegments(this.props);

    const depositButtonText = deposit
      ? `Deposit taken - ${currencySign({
          value: deposit.amount,
          currentSalonAbbr,
          currentSalonSign,
        })}`
      : 'Take Deposit';

    const repeatButtonText = isRepeatBooking
      ? `Repeats every ${frequency} weeks until ${formatDayToYearOrdinal(until)}`
      : 'Repeat Booking';

    const byStartTime = (agg, curr) =>
      curr.deleted || !moment(curr.start_time).isBefore(moment(agg.start_time)) ? agg : curr;

    const appointmentDate = moment(
      addedServices.length && addedServices[0].start_time
        ? addedServices.reduce(byStartTime).start_time
        : startTime || currentDay || void 1,
    );

    const flattenedServices = fromServicesToFlattened(services);

    return (
      <div
        data-bem="ServiceSelection"
        data-client-id={String(clientId)}
        data-service-id={String(serviceId)}
        data-shown-add={String(isAddButtonShown)}
        data-shown-take={String(isTakeButtonShown)}
        data-shown-repeat={String(isRepeatButtonShown)}
      >
        <div data-bem="ServiceSelection__booking-window" className="BookingWindow">
          <SalonModal tag="ServiceSelection__modal--warning" isOpen={showModal} withFooter>
            <SalonModal.Body>
              <div className={CN.modalContent}>
                <IconStatus variant="alert">
                  <Icon variant="alert" />
                </IconStatus>
                <div className={CN.modalTitle}>You have selected a different stylist</div>
                <span className={CN.modalText}>
                  The client has selected a different preferred stylist for this service. Continue with your chosen
                  stylist?
                </span>
              </div>
            </SalonModal.Body>
            <SalonModal.Footer>
              <div className={CN.modalButtons}>
                <Button
                  variant="outlineForce"
                  onClick={() => {
                    this.setState({ showModal: false });
                    removeService(serviceId, true);
                  }}
                >
                  <span className={CN.buttonSpace}>NO, GO BACK</span>
                </Button>
                <Button variant="primaryForce" onClick={() => void this.setState({ showModal: false })}>
                  <span className={CN.buttonSpace}>YES, CONTINUE</span>
                </Button>
              </div>
            </SalonModal.Footer>
          </SalonModal>

          <section data-bem="ServiceSelection__service-selection" className="service-selection sticky-header">
            <HeaderWrapper tag="ServiceSelection__service-selection-header">
              {category && <BackButton onClick={this.goBackToServiceList} />}
              <div
                role="button"
                tabIndex={0}
                onClick={() => void this.setState({ modalClose: true })}
                className="close-ico"
              >
                <img src={closeIco} alt="" />
              </div>
            </HeaderWrapper>

            <BWContent space tag="ServiceSelection__service-selection-content">
              {client !== null && client !== 'walkIn' && client !== undefined ? (
                <BWClientHeader
                  tag="ServiceSelection__service-selection-client-header"
                  client={client}
                  clientTags={clientTags}
                  editClient={editClient}
                  goToClientProfile={this.goToClientProfile}
                  goToEditClientProfile={this.goToEditClientProfile}
                  goToPatchView={this.goToPatchView}
                  noShow={this.showNoShowData(clientNoShowData)}
                  salonId={salonId}
                />
              ) : (
                <WalkIn pathArray={pathSegments} history={history} />
              )}

              {!isSearching && (
                <ToggleFeature flag="bookingInlineDatePicker">
                  <TextField htmlFor="bookingDayPicker" labelName="">
                    <div
                      data-bem="ServiceSelection__date-picker"
                      className="co-date-picker"
                      id="bookingDayPicker"
                      onMouseOver={this.handleMouseOver}
                      onMouseOut={this.handleMouseOut}
                    >
                      <div
                        className={cn({
                          'date-button': isDatePickerOpen,
                          'date-button-closed': !isDatePickerOpen,
                        })}
                        onClick={this.openDatePicker}
                        role="button"
                        tabIndex={-1}
                      >
                        <p className="edit-btn font-ProximaNova-sb black pt-4 font-18px">
                          {moment(appointmentDate).format('ddd ll')}
                        </p>

                        <button className="edit-btn font-ProximaNova-sb">
                          {isDatePickerOpen ? 'DONE' : 'CHANGE DATE'}
                        </button>
                      </div>
                      {isDatePickerOpen && (
                        <DatePickerInput
                          tag="ServiceSelection__appointment-date"
                          component={DatePickerInput.CommonDatePicker}
                          className="closed"
                          inline
                          selected={appointmentDate}
                          locale="en-GB"
                          onOutsideClick={alwaysNoop}
                          onChange={this.setBookingDate}
                          dayClassName={(date) => moment(date).isBefore(nowAsMoment(), 'day') && 'is-past-day'}
                        >
                          <div className={CN.pastDateTooltip} style={{ display: hoverPastDay ? 'block' : 'none' }}>
                            You are selecting a date in the past
                          </div>
                        </DatePickerInput>
                      )}
                      {isDatePickerOpen && (
                        <DatePickerInput
                          tag="ServiceSelection__selected-date"
                          component={DatePickerInput.WeeksComponent}
                          onChangeDate={this.setBookingDate}
                          selectedDate={moment(selectedDate)}
                        />
                      )}
                    </div>
                  </TextField>
                </ToggleFeature>
              )}

              {!isSearching &&
                addedServices &&
                addedServices.map((service, index) =>
                  service.deleted ? (
                    <div key={index} />
                  ) : (
                    <DropdownService
                      tag="ServiceSelection"
                      key={service.local_id}
                      backgroundColor={service.color}
                      borderColor={service.color}
                      index={index}
                      removedService={removedService}
                      service={service} // hardcoded
                      stylistList={stylistList}
                      textColor="white"
                    />
                  ),
                )}

              <div
                data-bem="ServiceSelection__more-options"
                className={cn({
                  'more-options-menu': true,
                  hide: !isAddButtonShown && !isTakeButtonShown && !isRepeatButtonShown,
                })}
              >
                {isAddButtonShown && clientId && (
                  <FrequentlyButtonButton onClickFrequentBtn={this.goToFrequentlyList} />
                )}

                {isAddButtonShown && (
                  <button
                    data-bem="ServiceSelection__add-service-button"
                    className="more-option-item"
                    key="add-service"
                    tabIndex="0"
                    onClick={this.goToAddService}
                  >
                    <img src={addserviceIco} alt="Add service" className="icon ico-booking-options" />
                    <div>Add Service</div>
                  </button>
                )}

                {isTakeButtonShown && clientId && !isRepeatBooking && !depositTaken && (
                  <button
                    data-bem="ServiceSelection__take-deposit-button"
                    className={cn({
                      'more-option-item': true,
                      disabled: deposit,
                    })}
                    key="take-deposit"
                    tabIndex="0"
                    onClick={this.takeDeposit}
                  >
                    <img src={depositIco} alt="Take deposist" className="icon ico-booking-options" />
                    <div>{depositButtonText}</div>
                  </button>
                )}

                {isRepeatButtonShown && !deposit && !isRepeatBooking && clientId && (
                  <ToggleFeature flag="repeatBookings">
                    <button
                      data-bem="ServiceSelection__repeat-booking-button"
                      className={cn({
                        'more-option-item': true,
                        disabled: isRepeatBooking,
                      })}
                      key="take-deposit"
                      tabIndex="0"
                      onClick={this.repeatBooking}
                    >
                      <img src={repeatBookingIco} alt="repeat-booking" className="icon ico-booking-options" />
                      <div>{repeatButtonText}</div>
                    </button>
                  </ToggleFeature>
                )}
              </div>

              {isRepeatBooking && (
                <div data-bem="ServiceSelection__is-repeat-booking" className="deposit-taken">
                  <div>{repeatButtonText}</div>
                </div>
              )}

              {depositTaken && (
                <div data-bem="ServiceSelection__has-deposit-taken" className="deposit-taken">
                  <div>{depositButtonText}</div>
                </div>
              )}

              {!isAddButtonShown && (
                <SearchSelectBar
                  options={flattenedServices}
                  onSelect={this.handleSelectedSearchedItem}
                  onStartSearching={this.setSearching}
                  placeholder={`Search from ${flattenedServices.length} services`}
                >
                  {(value, onSelect) => (
                    <ServiceItem key={value.id} service={value} onClickService={() => onSelect(value)} />
                  )}
                </SearchSelectBar>
              )}

              {!isSearching &&
                clientId &&
                frequentServices.length > 0 &&
                addedServices.filter((s) => !s.deleted).length === 0 && (
                  <FrequentlyBtnComponent onClickFrequentBtn={this.goToFrequentlyList} />
                )}

              <div data-bem="ServiceSelection__service-list" className="service-list">
                {fromAnyToBool(
                  !isSearching &&
                    !category &&
                    addedServices.length === 0 &&
                    !isAddButtonShown &&
                    !(clientId && frequentServices.isFetching),
                ) && (
                  <div data-bem="ServiceSelection__service-item">
                    {services.map((service) => (
                      <CategoryItem
                        key={service.id}
                        categoryName={service.name}
                        color={service.color}
                        onAddServiceCategory={() => void this.pickCategory(service)}
                      />
                    ))}
                  </div>
                )}
              </div>

              {!isSearching && (
                <TextField htmlFor="bookingnotes" labelName="Booking note">
                  <BookingNotes notes={bookingNotes} />
                </TextField>
              )}
            </BWContent>
          </section>

          {!isSearching && addedServices && addedServices.length > 0 && (
            <BookingSummary
              addedServices={addedServices}
              appointmentAndDepositThunk={appointmentAndDepositThunk}
              appointmentAndRepeatThunk={appointmentAndRepeatThunk}
              beFindReader={beFindReader}
              beCreateAppointment={beCreateAppointment}
              bookingNotes={bookingNotes}
              changeRepeatUntil={changeRepeatUntil}
              cleanBookingData={cleanBookingData}
              clientId={clientId}
              createAppointmentWithProcedures={createAppointmentWithProcedures}
              deposit={deposit}
              frequency={frequency}
              frequencyType={frequencyType}
              history={history}
              isFetching={isFetching}
              isFetchingService={isFetchingService}
              isRepeatBooking={isRepeatBooking}
              location={location}
              match={match}
              ref={this.bookingSummaryRef}
              salonId={salonId}
              until={until}
              updateAppointmentAndDepositThunk={updateAppointmentAndDepositThunk}
              updateAppointmentAndRepeatThunk={updateAppointmentAndRepeatThunk}
              updateAppointmentWithProcedures={updateAppointmentWithProcedures}
              feSidebarAppointmentClear={this.props.feSidebarAppointmentClear}
            />
          )}
        </div>

        <SalonModal tag="ServiceSelection__modal--exit" isOpen={modalClose} withFooter>
          <SalonModal.Body>
            <IconStatus variant="alert" width="lg">
              <Icon variant="alert" width="l1" />
            </IconStatus>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>Exit without saving?</div>
              <span className={CN.modalText} data-bem="ServiceSelection__SalonModal--exit">
                If you exit now, your booking will not be saved. Are you sure you want to exit?
              </span>
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <div className={CN.modalButtons}>
              <Button variant="outlineForce" onClick={() => void this.setState({ modalClose: false })}>
                <span className={CN.buttonSpace}>GO BACK</span>
              </Button>

              <Button
                variant="primaryForce"
                onClick={() => {
                  cleanBookingData();
                  navFor(CTAG, 'render()', 'onRight()', this.props).push(match.url.split('appointment')[0]);
                }}
              >
                <span className={CN.buttonSpace}>YES, EXIT</span>
              </Button>
            </div>
          </SalonModal.Footer>
        </SalonModal>
        {showReloadPopup && (
          <ConfirmationModalComponent
            popupTitle="Internet disconnect"
            popupMessage={RELOAD_MESSAGE}
            buttonText="Okay"
            buttonCallback={this.closeReloadPopup}
          />
        )}
      </div>
    );
  }
}

const ServiceSelectionHoc = connect(
  (state) => ({
    addedServices: state.booking.addedServices,
    bookingNotes: state.booking.notes,
    categoryServices: state.salon.services.categories,
    client: state.booking.client,
    clientDepositData: state.booking.clientDepositData,
    clientId: state.booking.client ? state.booking.client.id : null,
    clientNoShowData: state.booking.clientNoShowData,
    clientTags: selectBookingClientTags(state),
    currentDay: state.scheduler.currentDay,
    deposit: state.booking.deposit,
    depositTaken: state.booking.deposit ? state.booking.deposit.amount : null,
    editClient: state.booking.editClient,
    frequency: state.booking.frequency,
    frequencyType: state.booking.frequencyType,
    frequentServices: state.booking.frequentServices,
    isRepeatBooking: state.booking.isRepeatBooking,
    preferenceList: state.booking.preferenceList,
    salonId: selectCurrentSalonId(state),
    services: selectCurrentSalonServices(state),
    startTime: state.booking.startTime,
    stylistList: selectCurrentSalonStylists(state),
    until: state.booking.until,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        addService,
        appointmentAndDepositThunk,
        appointmentAndRepeatThunk,
        beFindReader: beFindReaderV1,
        beCreateAppointment,
        createAppointmentWithProcedures,
        cleanBookingData,
        getPreferenceList,
        hasHighNoShowRate,
        pickCategory,
        removeService,
        setCurrentDay,
        changeClient,
        getClient,
        getFrequentlyBookedList,
        trackEvent,
        updateAppointmentWithProcedures,
        updateAppointmentAndRepeatThunk,
        updateAppointmentAndDepositThunk,
        feSidebarAppointmentClear,
      },
      dispatch,
    ),
)(withSalonCurrency(ServiceSelection));

export default ServiceSelectionHoc;
